export default __webpack_public_path__ + "static/media/bg-login2.8b41043e.png";